var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenListIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292893 0.293076C0.683417 -0.097448 1.31658 -0.097448 1.70711 0.293076L7 5.58597L12.2929 0.293076C12.6834 -0.097448 13.3166 -0.097448 13.7071 0.293076C14.0976 0.683601 14.0976 1.31677 13.7071 1.70729L7.70711 7.70729C7.31658 8.09781 6.68342 8.09781 6.29289 7.70729L0.292893 1.70729C-0.0976311 1.31677 -0.0976311 0.683601 0.292893 0.293076Z",
    fill: "#143641"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenListIcon);
export default __webpack_public_path__ + "static/media/openListIcon.c081288ef6e4aa3b41c853f2827b30a8.svg";
export { ForwardRef as ReactComponent };